import React, { useContext, useState, useEffect } from "react";
import { UserInformationContext } from "../main/App";
import TeamInfo from "./TeamInfo";
import config from "../etc/config.json";
import { Container, Row, Col, ButtonGroup, Button } from "react-bootstrap";
import { getNationalTeam, getRegularTeam, hasNationalTeam } from "../common/Helpers";

function Team(props) {
  const { userInformation } = useContext(UserInformationContext);
  const [selectedTeam, setSelectedTeam] = useState('regularTeam');
  const [regularTeamId, setRegularTeamId] = useState(null);
  const [nationalTeamId, setNationalTeamId] = useState(null);

  useEffect(() => {
      if (userInformation) {
        setRegularTeamId(getRegularTeam(userInformation).id);
        if (hasNationalTeam(userInformation))
          setNationalTeamId(getNationalTeam(userInformation).id);
        else {
          setNationalTeamId(null);
          setSelectedTeam('regularTeam');
        }
      }
      else {
        setRegularTeamId(null);
        setNationalTeamId(null);
      }
  }, [userInformation]);

  return <Container fluid>
    {hasNationalTeam(userInformation) ?
      <Row>
        <Col>
          <ButtonGroup>
            <Button variant={(selectedTeam !== 'regularTeam' ? 'outline-' : '') + 'primary'}
              onClick={() => setSelectedTeam('regularTeam')}>Regular Team</Button>
            <Button variant={(selectedTeam !== 'nationalTeam' ? 'outline-' : '') + 'primary'}
              onClick={() => setSelectedTeam('nationalTeam')}>National Team</Button>
          </ButtonGroup>
        </Col>
      </Row>
    : null }
    <Row className="p-0 m-1 justify-content-center">
      <Col>
        {selectedTeam === 'nationalTeam' && nationalTeamId ? 
          <TeamInfo key={'nationalTeam'} teamId={nationalTeamId} />
          :
          <TeamInfo key={'regularTeam'} teamId={regularTeamId} />
        }
      </Col>
    </Row>
    <Row className="p-0 m-1 justify-content-center">
      <Col style={{ textAlign: "center" }}>
        <br />
        <br />
        <br />
        <br />
        <br />
        <p>Visit the <a href={config.FORUM_BASE_URL} target="_blank" rel="noreferrer">Forum</a> and <a href="http://radsportfreaks.de/RSFForum/viewforum.php?f=19" target="_blank" rel="noreferrer">present your team</a>.</p>
        <br />
        <br />
        <br />
      </Col>
    </Row>
  </Container>;
}

export default Team;